import { XpressClientLocationTypeEnum } from 'app/models';

export class XpressClientLocationTypeModel {
    public static XpressClientLocationTypeList: Array<any> = [
        { id: XpressClientLocationTypeEnum.Xpress, name: 'Main' },
        { id: XpressClientLocationTypeEnum.Boracay, name: 'Boracay' },
		{ id: XpressClientLocationTypeEnum.ElNido, name: 'El Nido' },
		{ id: XpressClientLocationTypeEnum.Dumaguete, name: 'Dumaguete' }

    ];
}
